module.exports = __webpack_public_path__ + "img/ico-chev-down--black.87f2fc74.svg";